import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import ReactTooltip from 'react-tooltip';

export class ConfiguracaoItinerarioReservaBpe extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      configuracaoSelecionada: null,
      idReservas: []
    };
  }

  exibirIconeMotivo(reservasBpe) {
    const bpeComErro = reservasBpe.tipoSituacaoTransmissaoBpe !== 'SUCESSO'
    const motivo = reservasBpe.descSituacaoErroBpe != null ? reservasBpe.descSituacaoErroBpe : 'Sem descrição do erro.'
    if (!bpeComErro) {
      return ''
    }
    return <span className="align-self-center tooltip-info ml-1">
      <a data-tip data-for={`nome-agencia-${reservasBpe.reservaId}`}>
        <i className="material-icons info" style={{ color: '#000' }}>&#xe88e;</i>
      </a>
      <div className="tooltip-ut">
        <ReactTooltip className="tooltip-ut" id={`nome-agencia-${reservasBpe.reservaId}`}
          type="dark" effect="solid">
          <div className="row">{motivo}</div>
        </ReactTooltip>
      </div>
    </span>
  }

  render() {
    const cor = this.props.reservasBpe.tipoSituacaoTransmissaoBpe !== 'SUCESSO' ? 'red' : 'green'
    let corReserva = 'black';
    if (this.props.reservasBpe.situacaoReserva === 'CANCELADO') {
      corReserva = 'red'
    } else if (this.props.reservasBpe.situacaoReserva === 'APROVADO') {
      corReserva = 'green'
    } else {
      corReserva = 'orange'
    }
    
    return (
      <div className="representante">
        <div className="resumo">
          <div className="row">
            <div className="col-lg-1 col-xl-1">
              <span className="titulo-mobile">Número Bilhete:&nbsp;</span>{this.props.reservasBpe.reservaId}
            </div>

            <div className="col-lg-1 col-xl-1">
              <span className="titulo-mobile">Número pedido:&nbsp;</span>{this.props.reservasBpe.pedidoId}
            </div>

            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Situacao Reserva:&nbsp;</span>
              <div style={{ color: corReserva }}>
                {this.props.reservasBpe.situacaoReserva}
              </div>
            </div>

            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">CCidade Origem:&nbsp;</span>{this.props.reservasBpe.origem}
            </div>

            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Cidade Destino:&nbsp;</span>{this.props.reservasBpe.destino}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Nome Passageiro:&nbsp;</span>{this.props.reservasBpe.nomePassageiro}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Situação Bpe:&nbsp;</span>
              <div style={{ color: cor }}>
                {this.props.reservasBpe.tipoSituacaoTransmissaoBpe}
                {this.exibirIconeMotivo(this.props.reservasBpe)}
              </div>
            </div>
            <div className="col-lg-2 col-xl-2">
              <div className="acoes">
                <div className="botoes">
                  {this.props.reservasBpe.tipoSituacaoTransmissaoBpe !== 'SUCESSO' && 
                    this.props.reservasBpe.situacaoReserva !==  'CANCELADO' ?
                    <input name='habilitadoBpe' type="checkbox"
                      label="Habilitar para emissão de BPe"
                      css="form-check-input"
                      value={this.props.reservasBpe.reservaId}
                      checked={this.props.idReservas.filter(it => it === this.props.reservasBpe.reservaId).length > 0}
                      onClick={() => this.props.adicionarReservas(this.props.reservasBpe.reservaId)}
                      readOnly={false} />
                    : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, { changeFieldValue })(
  (ConfiguracaoItinerarioReservaBpe))